/**
 * @generated SignedSource<<ee4089e8cb0675efb43999b69820cff8>>
 * @relayHash 6b4ffd2ad7f090c9ff9e48f46ca2e3f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57bb2e43ab39c523781b2e23eb3249b05f9bff8f400299123fdc181ecd1a160a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphIntegrationDirectoryItemType = "ACTION" | "CUSTOM_SKILL" | "FORGE_SKILL" | "FORGE_TOOL" | "MCP_SERVER" | "MCP_TOOL" | "PLATFORM_SKILL" | "SKILL" | "%future added value";
export type GraphIntegrationSkillSurface = "ROVO_AGENTS" | "ROVO_CLAW" | "STUDIO" | "%future added value";
export type GraphIntegrationSurface = "AUTOMATION" | "CSM" | "POLLINATOR" | "ROVO" | "ROVO_AGENTS" | "ROVO_CLAW" | "STUDIO" | "%future added value";
export type AgentStudioSkillsQuery$variables = {
  cloudId: string;
  contextAri: string;
  isForgeSkillsEnabled: boolean;
  isStudioCustomSkillsM1FrontendEnabled: boolean;
  productListSurface?: GraphIntegrationSkillSurface | null;
  relevantFor?: ReadonlyArray<GraphIntegrationDirectoryItemType> | null;
  skillListSurface: GraphIntegrationSurface;
};
export type AgentStudioSkillsQuery$data = {
  readonly connectedAppsQuery?: {
    readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_connectedAppsQuery">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SkillsFilter_productsQuery" | "SkillsList_AtlassianAgentStudioSkills_fragmentRef">;
};
export type AgentStudioSkillsQuery = {
  response: AgentStudioSkillsQuery$data;
  variables: AgentStudioSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForgeSkillsEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStudioCustomSkillsM1FrontendEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productListSurface"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillListSurface"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = {
  "kind": "Variable",
  "name": "relevantFor",
  "variableName": "relevantFor"
},
v9 = {
  "kind": "Variable",
  "name": "surface",
  "variableName": "skillListSurface"
},
v10 = {
  "kind": "Variable",
  "name": "contextAri",
  "variableName": "contextAri"
},
v11 = {
  "kind": "Variable",
  "name": "surface",
  "variableName": "productListSurface"
},
v12 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v8/*: any*/),
  (v9/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v17 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v19 = [
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": [
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "isStudioCustomSkillsM1FrontendEnabled",
            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
      },
      {
        "args": [
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SkillsFilter_productsQuery"
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    (v10/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "SkillsFilter_connectedAppsQuery"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "connectedAppsQuery"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentStudioSkillsQuery",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isGraphIntegrationDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "GraphIntegrationSkillUiMetadata",
                        "kind": "LinkedField",
                        "name": "uiMetadata",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "helpText"
                          }
                        ]
                      },
                      {
                        "concreteType": "GraphIntegrationSkillMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v18/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v14/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "tags"
                          },
                          {
                            "concreteType": "GraphIntegrationSkillTool",
                            "kind": "LinkedField",
                            "name": "tools",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "source"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "alias": "skillDescription",
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ],
                    "type": "GraphIntegrationSkillItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v19/*: any*/),
                    "type": "GraphIntegrationSkillDirectoryItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v12/*: any*/),
        "filters": [
          "cloudId",
          "relevantFor",
          "surface",
          "searchKeyword",
          "dimensionIds"
        ],
        "handle": "connection",
        "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      },
      {
        "condition": "isStudioCustomSkillsM1FrontendEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v14/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "products",
        "args": [
          (v10/*: any*/),
          {
            "kind": "Literal",
            "name": "dimension",
            "value": "PRODUCTS"
          },
          (v11/*: any*/)
        ],
        "concreteType": "GraphIntegrationSkillDimensionMetadata",
        "kind": "LinkedField",
        "name": "graphIntegration_skillDimensionMetadata",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v17/*: any*/)
                ],
                "type": "GraphIntegrationSkillProductItem"
              }
            ]
          }
        ]
      },
      {
        "condition": "isForgeSkillsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "forgeApps",
            "args": [
              (v10/*: any*/),
              {
                "kind": "Literal",
                "name": "dimension",
                "value": "FORGE_APPS"
              }
            ],
            "concreteType": "GraphIntegrationSkillDimensionMetadata",
            "kind": "LinkedField",
            "name": "graphIntegration_skillDimensionMetadata",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "57bb2e43ab39c523781b2e23eb3249b05f9bff8f400299123fdc181ecd1a160a",
    "metadata": {},
    "name": "AgentStudioSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8833b64a4a590b5f6605a37f76649189";

export default node;
